import React from 'react'

export type StatusLevel = 'pass' | 'fail' | 'warn' | 'info' | 'neutral'

export interface StatusIndicatorProps {
  /** Semantic status. Maps to: pass→success green, fail→danger red, warn→amber,
   * info→accent orange, neutral→muted grey (86cb6wu8t: an INFORMATIONAL marker,
   * never a verdict color — same rule CappedStateChip follows: "we stopped
   * looking" must never read like "you are being attacked right now"). */
  status: StatusLevel
  className?: string
}

const colorMap: Record<StatusLevel, string> = {
  pass: 'bg-eg-success',
  fail: 'bg-eg-danger',
  warn: 'bg-eg-amber',
  info: 'bg-eg-accent',
  neutral: 'bg-eg-text-muted',
}

/**
 * StatusIndicator — Editorial Grid
 *
 * Small colored dot used on domain cards, tables, and terminal overlays.
 * Exposes a `role="status"` + `aria-label` for accessible status announcements.
 */
export function StatusIndicator({
  status,
  className = '',
}: StatusIndicatorProps) {
  return (
    <span
      className={[
        'inline-block h-[7px] w-[7px] flex-shrink-0 rounded-full',
        colorMap[status],
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      role="status"
      aria-label={status}
    />
  )
}
